import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.css']
})
export class NavTabsComponent implements OnInit {
  productId: number;
  imageTypes = '.png, .jpg';
  videoTypes = '.mp4,.mpg,.m4v,.flv';

  constructor(private router: ActivatedRoute,) { }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.productId = + param.id;
    });
  }

}
